<template>

  <div>
    <b-form-group label="Naam op factuur" label-class="font-weight-bold">
      <b-input v-model="displayName"/>
    </b-form-group>

    <b-form-group label="Beschrijving" label-class="font-weight-bold">
      <b-textarea v-model="description" rows="4" />
    </b-form-group>

    <b-form-group label="Type" label-class="font-weight-bold">
      <b-form-radio-group v-model="type" :options="$options.types" />
    </b-form-group>

  </div>

</template>

<script>

import {NETWORK_ONLY} from '@/lib/constants';

export default
{
    data()
    {
        return {
            displayName: '',
            description: '',
            type: null
        }
    },
    async mounted()
    {
        if(this.id)
        {
            const {data: { cgroupById} }= await this.$apollo.query(
                {
                    query: require('../graphql/cgroup_for_edit.gql'),
                    variables: { id: this.id },
                    fetchPolicy: NETWORK_ONLY
                }
            );

            this.displayName = cgroupById.displayName;
            this.description = cgroupById.description;
            this.type = cgroupById.type;
        }
    },
    methods:
    {
        async create(ok)
        {
            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/mutation/create_cgroup.gql'),
                    variables:
                    {
                        input:
                        {
                            cgroup:
                            {
                                description: this.description,
                                displayName: this.displayName,
                                type: this.type
                            }
                        }
                    }
                }
            );
            ok();
        },
        async saveEdit(ok)
        {
            const variables =
            {
                id: this.id,
                patch:
                {
                    description: this.description,
                    displayName: this.displayName
                }
            };

            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/mutation/updateCGroup.gql'),
                    variables
                }
            );

            await ok();
        }
    },
    props:
    {
        id: {  }
    },
    types: ['COUNTER', 'GAUGE']
}
</script>

<style>
</style>